{
  "level": "eb02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:eb02",
    "objects": "AREAS.E3:eb02.e3",
    "mesh": "TREES.E3:eb02.e3"
  },
  "spawn_point": {
    "position": [
      1904.4923899096111,
      1829.6274607103924,
      144.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1904.4923899096111,
      1929.6274607103924,
      144.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1750.0,
      1555.0,
      120.0
    ],
    "bbox_max": [
      2025.0001220703125,
      2014.9998779296875,
      165.0
    ],
    "vertex_count": 430,
    "vertices": [
      [
        1852.5,
        1555.0001220703125,
        127.5
      ],
      [
        1847.5,
        1555.0001220703125,
        135.0
      ],
      [
        1847.5,
        1555.0001220703125,
        120.0
      ],
      [
        1852.5,
        1555.0001220703125,
        127.5
      ],
      [
        1827.5001220703125,
        1555.0001220703125,
        127.5
      ],
      [
        1832.5,
        1555.0001220703125,
        120.0
      ],
      [
        1832.5,
        1555.0001220703125,
        135.0
      ],
      [
        1827.5001220703125,
        1555.0001220703125,
        127.5
      ],
      [
        2014.9998779296875,
        1601.9998779296875,
        165.0
      ],
      [
        1803.0001220703125,
        1845.0001220703125,
        140.0
      ],
      [
        1802.9998779296875,
        1824.9998779296875,
        140.0
      ],
      [
        1802.9998779296875,
        1824.9998779296875,
        140.0
      ],
      [
        1818.0,
        1825.0,
        140.0
      ],
      [
        1836.2940673828125,
        1769.82958984375,
        140.0
      ],
      [
        1839.82958984375,
        1766.2940673828125,
        140.0
      ],
      [
        1846.2940673828125,
        1759.82958984375,
        140.0
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        140.0
      ],
      [
        1840.17041015625,
        1753.7059326171875,
        140.0
      ],
      [
        1841.4644775390625,
        1758.5355224609375,
        140.0
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        140.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        140.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        140.0
      ],
      [
        1843.7059326171875,
        1750.17041015625,
        140.0
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        140.0
      ],
      [
        1838.53564453125,
        1758.53564453125,
        140.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        140.0
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        140.0
      ],
      [
        1838.53564453125,
        1758.53564453125,
        140.0
      ],
      [
        1839.8297119140625,
        1753.7060546875,
        140.0
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        140.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        140.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        140.0
      ],
      [
        1836.2940673828125,
        1769.82958984375,
        140.0
      ],
      [
        1838.5355224609375,
        1761.4644775390625,
        140.0
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        140.0
      ],
      [
        1840.17041015625,
        1766.2940673828125,
        140.0
      ],
      [
        1843.7059326171875,
        1769.82958984375,
        140.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        140.0
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        140.0
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        140.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        140.0
      ],
      [
        1843.7059326171875,
        1769.82958984375,
        140.0
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        140.0
      ],
      [
        2025.0001220703125,
        1602.0001220703125,
        140.0
      ],
      [
        2014.9998779296875,
        1601.9998779296875,
        140.0
      ],
      [
        2014.9998779296875,
        1601.9998779296875,
        140.0
      ],
      [
        2015.0,
        1578.0,
        145.0
      ],
      [
        2025.0,
        1578.0,
        145.0
      ],
      [
        2015.0,
        1578.0,
        145.0
      ],
      [
        1840.0,
        1700.4000244140625,
        160.07728576660156
      ],
      [
        1841.492919921875,
        1700.4000244140625,
        160.0
      ],
      [
        1847.5,
        1700.4000244140625,
        160.0
      ],
      [
        1847.7147216796875,
        1700.4000244140625,
        159.67794799804688
      ],
      [
        1840.0,
        1700.4000244140625,
        160.07728576660156
      ],
      [
        1838.507080078125,
        1700.4000244140625,
        160.0
      ],
      [
        1832.4998779296875,
        1700.4000244140625,
        160.0
      ],
      [
        1832.28515625,
        1700.4000244140625,
        159.677978515625
      ],
      [
        1849.5975341796875,
        1700.4000244140625,
        156.85357666015625
      ],
      [
        1860.8118896484375,
        1700.4000244140625,
        152.5
      ],
      [
        1849.5975341796875,
        1700.4000244140625,
        156.85357666015625
      ],
      [
        1819.1884765625,
        1700.4000244140625,
        152.5
      ],
      [
        1830.40234375,
        1700.4000244140625,
        156.85362243652344
      ],
      [
        1830.40234375,
        1700.4000244140625,
        156.85362243652344
      ],
      [
        1860.8118896484375,
        1700.4000244140625,
        152.5
      ],
      [
        1849.5975341796875,
        1700.4000244140625,
        148.14642333984375
      ],
      [
        1830.40234375,
        1700.4000244140625,
        148.14637756347656
      ],
      [
        1819.1884765625,
        1700.4000244140625,
        152.5
      ],
      [
        1854.2088623046875,
        1700.4000244140625,
        149.93658447265625
      ],
      [
        1825.791015625,
        1700.4000244140625,
        149.9366455078125
      ],
      [
        1900.0,
        1864.322998046875,
        135.0
      ],
      [
        1900.0,
        1965.0,
        135.0
      ],
      [
        1900.0,
        1555.0,
        135.0
      ],
      [
        1899.9998779296875,
        1656.476806640625,
        135.0
      ],
      [
        1900.0,
        1965.0,
        135.0
      ],
      [
        1978.7247314453125,
        1980.0001220703125,
        135.0
      ],
      [
        1978.724609375,
        1985.0,
        135.0
      ],
      [
        1978.724609375,
        1995.0,
        135.0
      ],
      [
        1978.724609375,
        2000.0,
        135.0
      ],
      [
        1978.724609375,
        2010.0,
        135.0
      ],
      [
        1978.7244873046875,
        2014.9998779296875,
        135.0
      ],
      [
        1978.724609375,
        1995.0,
        135.0
      ],
      [
        1978.724609375,
        2010.0,
        135.0
      ],
      [
        1978.7244873046875,
        2014.9998779296875,
        135.0
      ],
      [
        1978.724609375,
        2000.0,
        135.0
      ],
      [
        1978.724609375,
        1985.0,
        135.0
      ],
      [
        1978.7247314453125,
        1980.0001220703125,
        135.0
      ],
      [
        1943.923095703125,
        1700.4000244140625,
        135.0
      ],
      [
        1899.9998779296875,
        1656.476806640625,
        135.0
      ],
      [
        1900.0,
        1864.322998046875,
        135.0
      ],
      [
        1943.923095703125,
        1820.4000244140625,
        135.0
      ],
      [
        1943.923095703125,
        1820.4000244140625,
        135.0
      ],
      [
        1948.9803466796875,
        1801.39990234375,
        135.0
      ],
      [
        1948.9803466796875,
        1801.39990234375,
        135.0
      ],
      [
        1960.0,
        1760.0,
        135.0
      ],
      [
        1943.923095703125,
        1700.4000244140625,
        135.0
      ],
      [
        1949.08203125,
        1719.5250244140625,
        135.0
      ],
      [
        1960.0,
        1760.0,
        135.0
      ],
      [
        1949.08203125,
        1719.5250244140625,
        135.0
      ],
      [
        1990.0,
        1765.0,
        135.0
      ],
      [
        1990.0001220703125,
        1755.0001220703125,
        135.0
      ],
      [
        1990.0,
        1765.0,
        135.0
      ],
      [
        1999.3232421875,
        1765.0,
        135.0
      ],
      [
        1999.3232421875,
        1765.0,
        140.0
      ],
      [
        1990.0001220703125,
        1755.0001220703125,
        135.0
      ],
      [
        1998.5230712890625,
        1755.0,
        140.0
      ],
      [
        1998.5230712890625,
        1755.0,
        135.0
      ],
      [
        2000.0,
        1756.4769287109375,
        140.0
      ],
      [
        2000.0,
        1764.3232421875,
        140.0
      ],
      [
        2000.0,
        1764.3232421875,
        135.0
      ],
      [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      [
        1990.0001220703125,
        1855.0001220703125,
        135.0
      ],
      [
        2000.0001220703125,
        1855.0,
        135.0
      ],
      [
        1989.9998779296875,
        1899.9998779296875,
        135.0
      ],
      [
        2000.0001220703125,
        1900.0001220703125,
        135.0
      ],
      [
        1990.0001220703125,
        1910.0001220703125,
        135.0
      ],
      [
        1989.9998779296875,
        1899.9998779296875,
        135.0
      ],
      [
        1990.0001220703125,
        1910.0001220703125,
        135.0
      ],
      [
        2000.0,
        1910.0,
        135.0
      ],
      [
        2000.0001220703125,
        1900.0001220703125,
        135.0
      ],
      [
        2000.0,
        1910.0,
        135.0
      ],
      [
        2000.0001220703125,
        1855.0,
        135.0
      ],
      [
        2000.0,
        1865.0,
        135.0
      ],
      [
        1990.0001220703125,
        1865.0,
        135.0
      ],
      [
        2000.0,
        1865.0,
        135.0
      ],
      [
        1990.0001220703125,
        1865.0,
        135.0
      ],
      [
        1990.0001220703125,
        1855.0001220703125,
        135.0
      ],
      [
        1990.0,
        1805.0,
        135.0
      ],
      [
        2000.0,
        1805.0,
        135.0
      ],
      [
        1990.0,
        1815.0,
        135.0
      ],
      [
        2000.0,
        1815.0,
        135.0
      ],
      [
        1990.0,
        1815.0,
        135.0
      ],
      [
        1990.0,
        1805.0,
        135.0
      ],
      [
        2000.0,
        1805.0,
        135.0
      ],
      [
        2000.0,
        1815.0,
        135.0
      ],
      [
        2000.0,
        1765.0,
        135.0
      ],
      [
        2000.0,
        1765.0,
        135.0
      ],
      [
        2025.0001220703125,
        1594.0001220703125,
        135.0
      ],
      [
        2014.9998779296875,
        1593.9998779296875,
        135.0
      ],
      [
        2014.9998779296875,
        1602.178466796875,
        135.0
      ],
      [
        2025.0001220703125,
        1602.1787109375,
        135.0
      ],
      [
        2014.9998779296875,
        1593.9998779296875,
        135.0
      ],
      [
        2014.9998779296875,
        1602.178466796875,
        135.0
      ],
      [
        1990.0,
        1665.0,
        135.0
      ],
      [
        2000.0,
        1665.0,
        135.0
      ],
      [
        1990.0,
        1620.0,
        135.0
      ],
      [
        2000.0,
        1620.0,
        135.0
      ],
      [
        1990.0,
        1620.0,
        135.0
      ],
      [
        1990.0,
        1610.0,
        135.0
      ],
      [
        2000.0,
        1610.0,
        135.0
      ],
      [
        2000.0,
        1620.0,
        135.0
      ],
      [
        1990.0,
        1610.0,
        135.0
      ],
      [
        2000.0,
        1610.0,
        135.0
      ],
      [
        1990.0,
        1665.0,
        135.0
      ],
      [
        1990.0,
        1655.0,
        135.0
      ],
      [
        2000.0,
        1655.0,
        135.0
      ],
      [
        2000.0,
        1665.0,
        135.0
      ],
      [
        1990.0,
        1655.0,
        135.0
      ],
      [
        2000.0,
        1655.0,
        135.0
      ],
      [
        1990.0,
        1715.0,
        135.0
      ],
      [
        2000.0,
        1715.0,
        135.0
      ],
      [
        1990.0,
        1715.0,
        135.0
      ],
      [
        1990.0,
        1705.0,
        135.0
      ],
      [
        2000.0,
        1705.0,
        135.0
      ],
      [
        2000.0,
        1715.0,
        135.0
      ],
      [
        1990.0,
        1705.0,
        135.0
      ],
      [
        2000.0,
        1705.0,
        135.0
      ],
      [
        2000.0,
        1755.0,
        135.0
      ],
      [
        2000.0,
        1755.0,
        135.0
      ],
      [
        1899.9993896484375,
        2010.0,
        127.5
      ],
      [
        1899.9993896484375,
        2005.0,
        120.0
      ],
      [
        1899.9993896484375,
        2005.0,
        135.0
      ],
      [
        1899.9993896484375,
        2010.0,
        127.5
      ],
      [
        1899.9993896484375,
        1990.0,
        120.0
      ],
      [
        1899.9993896484375,
        1985.0001220703125,
        127.5
      ],
      [
        1899.999755859375,
        1779.3197021484375,
        127.5
      ],
      [
        1899.999755859375,
        1770.11865234375,
        123.92801666259766
      ],
      [
        1899.999755859375,
        1767.5,
        120.0
      ],
      [
        1899.999755859375,
        1770.11865234375,
        123.92801666259766
      ],
      [
        1856.0819091796875,
        1984.1885986328125,
        128.71722412109375
      ],
      [
        1853.7867431640625,
        1983.7132568359375,
        129.43020629882812
      ],
      [
        1853.7867431640625,
        1983.7132568359375,
        129.43020629882812
      ],
      [
        1851.4998779296875,
        1775.307373046875,
        126.0
      ],
      [
        1851.4998779296875,
        1744.692626953125,
        126.0
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        123.92813110351562
      ],
      [
        1899.999755859375,
        1744.5443115234375,
        126.0
      ],
      [
        1895.5478515625,
        1727.929443359375,
        126.0
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        123.92813110351562
      ],
      [
        1899.999755859375,
        1752.4998779296875,
        120.0
      ],
      [
        1851.4998779296875,
        1775.307373046875,
        126.0
      ],
      [
        1850.670654296875,
        1778.4820556640625,
        124.75614166259766
      ],
      [
        1850.670654296875,
        1741.5181884765625,
        124.75625610351562
      ],
      [
        1851.4998779296875,
        1744.692626953125,
        126.0
      ],
      [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      [
        1849.499755859375,
        1738.7801513671875,
        123.0
      ],
      [
        1847.4998779296875,
        1781.755859375,
        120.0
      ],
      [
        1849.499755859375,
        1781.219970703125,
        123.0
      ],
      [
        1849.499755859375,
        1738.7801513671875,
        123.0
      ],
      [
        1850.670654296875,
        1741.5181884765625,
        124.75625610351562
      ],
      [
        1849.499755859375,
        1781.219970703125,
        123.0
      ],
      [
        1850.670654296875,
        1778.4820556640625,
        124.75614166259766
      ],
      [
        1899.999755859375,
        1770.11865234375,
        131.07199096679688
      ],
      [
        1899.999755859375,
        1779.3197021484375,
        127.5
      ],
      [
        1899.999755859375,
        1770.11865234375,
        131.07199096679688
      ],
      [
        1899.999755859375,
        1767.5,
        135.0
      ],
      [
        1899.999755859375,
        1740.6805419921875,
        127.5
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        131.07186889648438
      ],
      [
        1899.999755859375,
        1752.4998779296875,
        135.0
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        131.07186889648438
      ],
      [
        1857.5,
        1704.6890869140625,
        135.0
      ],
      [
        1899.999755859375,
        1740.6805419921875,
        127.5
      ],
      [
        1899.9993896484375,
        1985.0001220703125,
        127.5
      ],
      [
        1899.9993896484375,
        1990.0,
        135.0
      ],
      [
        1857.5,
        1988.9644775390625,
        135.0
      ],
      [
        1899.9993896484375,
        1998.4998779296875,
        120.0
      ],
      [
        1899.9993896484375,
        1998.4998779296875,
        123.0
      ],
      [
        1849.4998779296875,
        1992.1507568359375,
        123.0
      ],
      [
        1849.4998779296875,
        1994.1507568359375,
        123.0
      ],
      [
        1899.9993896484375,
        1996.5,
        123.0
      ],
      [
        1899.9993896484375,
        1998.4998779296875,
        123.0
      ],
      [
        1899.9993896484375,
        1996.5,
        120.0
      ],
      [
        1899.9993896484375,
        1996.5,
        123.0
      ],
      [
        1855.171630859375,
        1996.5,
        120.0
      ],
      [
        1855.1715087890625,
        1996.5,
        123.0
      ],
      [
        1847.4998779296875,
        1991.3223876953125,
        120.0
      ],
      [
        1849.4998779296875,
        1992.1507568359375,
        123.0
      ],
      [
        1847.4998779296875,
        1993.322265625,
        120.0
      ],
      [
        1849.4998779296875,
        1994.1507568359375,
        123.0
      ],
      [
        1847.4998779296875,
        1999.822265625,
        120.0
      ],
      [
        1852.5,
        2006.893310546875,
        127.5
      ],
      [
        1852.5,
        2006.893310546875,
        127.5
      ],
      [
        1857.5,
        2003.9644775390625,
        135.0
      ],
      [
        1940.0,
        1980.0,
        120.0
      ],
      [
        1953.0,
        1983.3331298828125,
        125.0
      ],
      [
        1967.0,
        1983.3331298828125,
        125.0
      ],
      [
        1950.0,
        1982.0,
        123.0
      ],
      [
        1953.0,
        1983.3331298828125,
        125.0
      ],
      [
        1970.0,
        1981.9998779296875,
        123.0
      ],
      [
        1967.0,
        1983.3331298828125,
        125.0
      ],
      [
        1950.0,
        1982.0,
        123.0
      ],
      [
        1970.0,
        1981.9998779296875,
        123.0
      ],
      [
        1961.0,
        1985.0,
        127.5002212524414
      ],
      [
        1959.0,
        1985.0,
        127.5002212524414
      ],
      [
        1961.0001220703125,
        1984.5001220703125,
        126.75044250488281
      ],
      [
        1959.0,
        1984.5,
        126.7502212524414
      ],
      [
        1959.0,
        1985.0,
        127.5002212524414
      ],
      [
        1959.0,
        1984.5,
        126.7502212524414
      ],
      [
        1961.0001220703125,
        1984.5001220703125,
        126.75044250488281
      ],
      [
        1961.0,
        1985.0,
        127.5002212524414
      ],
      [
        1959.9998779296875,
        1987.999755859375,
        132.0
      ],
      [
        1959.9998779296875,
        1984.9998779296875,
        127.5
      ],
      [
        1959.9998779296875,
        1984.9998779296875,
        127.5
      ],
      [
        1959.9998779296875,
        1987.999755859375,
        132.0
      ],
      [
        1958.0,
        1986.6668701171875,
        125.0
      ],
      [
        1962.0,
        1986.6668701171875,
        125.0
      ],
      [
        1955.0,
        1990.0001220703125,
        120.0
      ],
      [
        1955.0,
        1988.000244140625,
        123.0
      ],
      [
        1965.0,
        1988.000244140625,
        123.0
      ],
      [
        1965.0,
        1990.0001220703125,
        120.0
      ],
      [
        1955.0,
        1988.000244140625,
        123.0
      ],
      [
        1958.0,
        1986.6668701171875,
        125.0
      ],
      [
        1965.0,
        1988.000244140625,
        123.0
      ],
      [
        1962.0,
        1986.6668701171875,
        125.0
      ],
      [
        1959.9998779296875,
        1986.6669921875,
        125.0
      ],
      [
        1959.9998779296875,
        1986.6669921875,
        125.0
      ],
      [
        1939.9998779296875,
        2014.999755859375,
        120.0
      ],
      [
        1967.0,
        2011.6663818359375,
        125.0
      ],
      [
        1953.0,
        2011.66650390625,
        125.0
      ],
      [
        1970.0,
        2012.999755859375,
        123.0
      ],
      [
        1967.0,
        2011.6663818359375,
        125.0
      ],
      [
        1950.0,
        2012.999755859375,
        123.0
      ],
      [
        1953.0,
        2011.66650390625,
        125.0
      ],
      [
        1950.0,
        2012.999755859375,
        123.0
      ],
      [
        1970.0,
        2012.999755859375,
        123.0
      ],
      [
        1959.0,
        2009.5,
        128.2496795654297
      ],
      [
        1960.9998779296875,
        2009.4998779296875,
        128.24989318847656
      ],
      [
        1959.0,
        2010.0,
        127.49968719482422
      ],
      [
        1961.0001220703125,
        2010.0001220703125,
        127.49946594238281
      ],
      [
        1960.9998779296875,
        2009.4998779296875,
        128.24989318847656
      ],
      [
        1961.0001220703125,
        2010.0001220703125,
        127.49946594238281
      ],
      [
        1959.0,
        2010.0,
        127.49968719482422
      ],
      [
        1959.0,
        2009.5,
        128.2496795654297
      ],
      [
        1960.0,
        2009.5,
        128.2496795654297
      ],
      [
        1960.0,
        2006.999755859375,
        132.0
      ],
      [
        1960.0,
        2006.999755859375,
        132.0
      ],
      [
        1960.0,
        2009.5,
        128.2496795654297
      ],
      [
        1958.0001220703125,
        2008.333251953125,
        125.0
      ],
      [
        1962.0,
        2008.333251953125,
        125.0
      ],
      [
        1955.0,
        2005.0,
        120.0
      ],
      [
        1955.0,
        2006.9998779296875,
        123.0
      ],
      [
        1965.0,
        2006.9998779296875,
        123.0
      ],
      [
        1965.0,
        2005.0,
        120.0
      ],
      [
        1955.0,
        2006.9998779296875,
        123.0
      ],
      [
        1958.0001220703125,
        2008.333251953125,
        125.0
      ],
      [
        1965.0,
        2006.9998779296875,
        123.0
      ],
      [
        1962.0,
        2008.333251953125,
        125.0
      ],
      [
        1959.0,
        2009.5,
        126.75016784667969
      ],
      [
        1960.9998779296875,
        2009.4998779296875,
        126.74993896484375
      ],
      [
        1959.0,
        2009.5,
        126.75016784667969
      ],
      [
        1960.9998779296875,
        2009.4998779296875,
        126.74993896484375
      ],
      [
        1960.0,
        2009.5,
        126.75016784667969
      ],
      [
        1960.0,
        2008.333251953125,
        125.0
      ],
      [
        1960.0,
        2008.333251953125,
        125.0
      ],
      [
        1960.0,
        2009.5,
        126.75016784667969
      ],
      [
        1955.0,
        1996.5,
        120.0
      ],
      [
        1955.0,
        1998.4998779296875,
        120.0
      ],
      [
        1955.0,
        1998.4998779296875,
        123.0
      ],
      [
        1955.0,
        1996.5,
        123.0
      ],
      [
        1965.0,
        1996.5,
        123.0
      ],
      [
        1965.0,
        1998.4998779296875,
        123.0
      ],
      [
        1965.0,
        1998.4998779296875,
        120.0
      ],
      [
        1965.0,
        1996.5,
        120.0
      ],
      [
        1960.0,
        2009.4998779296875,
        128.24978637695312
      ],
      [
        1960.0,
        2009.4998779296875,
        126.75005340576172
      ],
      [
        1930.0,
        1777.5,
        120.0
      ],
      [
        1899.999755859375,
        1773.9022216796875,
        125.39684295654297
      ],
      [
        1948.6839599609375,
        1794.9998779296875,
        130.0
      ],
      [
        1949.2164306640625,
        1793.0,
        124.0
      ],
      [
        1948.6839599609375,
        1794.9998779296875,
        130.0
      ],
      [
        1949.2164306640625,
        1793.0,
        124.0
      ],
      [
        1958.993408203125,
        1756.268310546875,
        132.0
      ],
      [
        1958.993408203125,
        1756.268310546875,
        123.0
      ],
      [
        1948.8287353515625,
        1726.0,
        130.0
      ],
      [
        1949.3681640625,
        1728.0001220703125,
        124.0
      ],
      [
        1948.8287353515625,
        1726.0,
        130.0
      ],
      [
        1949.3681640625,
        1728.0001220703125,
        124.0
      ],
      [
        1949.3681640625,
        1728.0001220703125,
        124.0
      ],
      [
        1930.0,
        1742.5003662109375,
        120.0
      ],
      [
        1899.999755859375,
        1746.0980224609375,
        125.3968505859375
      ],
      [
        1999.3232421875,
        1765.0,
        120.0
      ],
      [
        1999.3232421875,
        1765.0,
        135.0
      ],
      [
        1998.5230712890625,
        1755.0,
        135.0
      ],
      [
        1998.5230712890625,
        1755.0,
        120.0
      ],
      [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      [
        2000.0,
        1764.3232421875,
        135.0
      ],
      [
        2000.0,
        1764.3232421875,
        120.0
      ],
      [
        2000.0,
        1756.4769287109375,
        120.0
      ],
      [
        1847.4998779296875,
        1999.822265625,
        135.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        131.50558471679688
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        133.44677734375
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        133.44677734375
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        131.50558471679688
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        131.50558471679688
      ],
      [
        1847.5,
        1758.6236572265625,
        135.0
      ],
      [
        1847.5,
        1751.18701171875,
        135.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        133.44677734375
      ],
      [
        1847.5,
        1761.3763427734375,
        135.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        131.50558471679688
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        133.44677734375
      ],
      [
        1847.5,
        1768.81298828125,
        135.0
      ],
      [
        1763.46728515625,
        1747.5,
        127.5
      ],
      [
        1765.5384521484375,
        1752.5,
        135.0
      ],
      [
        1751.39599609375,
        1752.5001220703125,
        120.0
      ],
      [
        1763.46728515625,
        1747.5,
        127.5
      ],
      [
        1750.5382080078125,
        1767.5,
        135.0
      ],
      [
        1750.0,
        1767.722900390625,
        134.6656036376953
      ],
      [
        1765.538330078125,
        1752.5,
        120.0
      ],
      [
        1750.5382080078125,
        1767.5,
        120.0
      ],
      [
        1750.0,
        1767.722900390625,
        120.33439636230469
      ],
      [
        1763.4674072265625,
        1772.5,
        127.5
      ],
      [
        1765.53857421875,
        1767.5,
        120.0
      ],
      [
        1751.3963623046875,
        1767.5,
        135.0
      ],
      [
        1763.4674072265625,
        1772.5,
        127.5
      ],
      [
        1818.0,
        1825.0,
        125.34430694580078
      ],
      [
        1808.8963623046875,
        1824.9998779296875,
        135.0
      ],
      [
        1822.499755859375,
        1840.0,
        135.0
      ],
      [
        1820.0,
        1830.0,
        128.5260009765625
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        130.6474151611328
      ],
      [
        1828.0384521484375,
        1830.0,
        120.0
      ],
      [
        1820.96728515625,
        1830.0,
        127.5
      ],
      [
        1820.96728515625,
        1830.0,
        127.5
      ],
      [
        1820.0,
        1830.0,
        128.52598571777344
      ],
      [
        1765.53857421875,
        1767.5,
        135.0
      ],
      [
        1818.0,
        1825.0,
        129.6557159423828
      ],
      [
        1815.967529296875,
        1825.0,
        127.5000228881836
      ],
      [
        1824.7940673828125,
        1830.0,
        131.5587921142578
      ],
      [
        1822.499755859375,
        1830.0,
        135.0
      ],
      [
        1828.5,
        1744.6927490234375,
        126.0
      ],
      [
        1828.5,
        1775.3072509765625,
        126.0
      ],
      [
        1778.940185546875,
        1771.4998779296875,
        126.0
      ],
      [
        1784.4520263671875,
        1792.0704345703125,
        126.0
      ],
      [
        1778.940185546875,
        1771.4998779296875,
        126.0
      ],
      [
        1763.881591796875,
        1771.5,
        126.0
      ],
      [
        1777.990478515625,
        1752.4998779296875,
        120.0
      ],
      [
        1772.7774658203125,
        1748.5,
        126.0
      ],
      [
        1763.8814697265625,
        1748.5,
        126.0
      ],
      [
        1784.4521484375,
        1727.929443359375,
        126.0
      ],
      [
        1778.9403076171875,
        1748.5,
        126.0
      ],
      [
        1778.9403076171875,
        1748.5,
        126.0
      ],
      [
        1829.3292236328125,
        1778.4822998046875,
        124.75595092773438
      ],
      [
        1828.5,
        1775.3072509765625,
        126.0
      ],
      [
        1832.4996337890625,
        1781.755615234375,
        120.0
      ],
      [
        1830.499755859375,
        1781.2197265625,
        123.0
      ],
      [
        1830.499755859375,
        1781.2197265625,
        123.0
      ],
      [
        1829.3292236328125,
        1778.4822998046875,
        124.75595092773438
      ],
      [
        1771.4739990234375,
        1747.5,
        127.5
      ],
      [
        1777.9903564453125,
        1752.4998779296875,
        135.0
      ],
      [
        1776.8695068359375,
        1771.4998779296875,
        126.0
      ],
      [
        1771.4739990234375,
        1747.5,
        127.5
      ],
      [
        1770.7066650390625,
        1748.5,
        126.0
      ],
      [
        1776.869873046875,
        1748.5,
        126.0
      ],
      [
        1822.4998779296875,
        1704.6890869140625,
        135.0
      ],
      [
        1822.499755859375,
        1815.310791015625,
        135.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        133.44677734375
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        131.50558471679688
      ],
      [
        1832.5,
        1758.6236572265625,
        135.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        131.50558471679688
      ],
      [
        1832.4998779296875,
        1768.81298828125,
        135.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        133.44677734375
      ],
      [
        1841.0,
        1982.328369140625,
        120.0
      ],
      [
        1841.0,
        1982.328369140625,
        123.0
      ],
      [
        1839.0,
        1783.4974365234375,
        120.0
      ],
      [
        1839.0,
        1783.4974365234375,
        123.0
      ],
      [
        1841.0,
        1736.5025634765625,
        120.0
      ],
      [
        1841.0,
        1736.5025634765625,
        123.0
      ],
      [
        1841.0,
        1783.4974365234375,
        120.0
      ],
      [
        1841.0,
        1783.4974365234375,
        123.0
      ],
      [
        1839.140380859375,
        1998.359619140625,
        123.0
      ],
      [
        1839.0,
        1993.1923828125,
        120.0
      ],
      [
        1839.0,
        1998.020751953125,
        123.0
      ],
      [
        1841.0,
        1997.1298828125,
        120.0
      ],
      [
        1839.140380859375,
        1998.359619140625,
        123.0
      ],
      [
        1841.0,
        1999.1298828125,
        123.0
      ],
      [
        1849.4998779296875,
        2002.650634765625,
        123.0
      ],
      [
        1847.56494140625,
        1993.3492431640625,
        120.09761047363281
      ],
      [
        1847.56494140625,
        1993.3492431640625,
        123.0
      ],
      [
        1830.5,
        1977.5,
        123.0
      ],
      [
        1837.7261962890625,
        1999.7738037109375,
        126.0
      ],
      [
        1828.5,
        1977.5,
        126.0
      ],
      [
        1837.7261962890625,
        1999.7738037109375,
        126.0
      ],
      [
        1851.5,
        2005.4791259765625,
        126.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1655.0,
      "bbox_min": [
        1655.0,
        1510.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -5.954652806394733e-07,
        0.0
      ],
      "plane_d": 2025.0010986328125,
      "bbox_min": [
        1655.0,
        1510.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        190.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -3.299196578154806e-07,
        1.0,
        0.0
      ],
      "plane_d": -1554.99951171875,
      "bbox_min": [
        1655.0,
        1510.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.32583823800086975,
        0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": -527.9386596679688,
      "bbox_min": [
        1819.9998779296875,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583779096603394,
        0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": -661.6688842773438,
      "bbox_min": [
        1819.9998779296875,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866414189338684,
        0.32583993673324585,
        -0.5244269967079163
      ],
      "plane_d": 1021.5097045898438,
      "bbox_min": [
        1819.9998779296875,
        1515.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866423726081848,
        0.3258380591869354,
        0.5244265794754028
      ],
      "plane_d": 887.7854614257812,
      "bbox_min": [
        1819.9998779296875,
        1515.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1819.9998779296875,
        1515.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -6.524487616843544e-07,
        -0.5547002553939819
      ],
      "plane_d": 1612.0985107421875,
      "bbox_min": [
        1827.5001220703125,
        1542.4998779296875,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547002553939819
      ],
      "plane_d": 1470.64892578125,
      "bbox_min": [
        1827.5001220703125,
        1542.4998779296875,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.524541618091462e-07,
        0.5546908378601074
      ],
      "plane_d": -1591.307373046875,
      "bbox_min": [
        1827.5001220703125,
        1542.5,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.367607738866354e-07,
        -0.5546908378601074
      ],
      "plane_d": -1449.861328125,
      "bbox_min": [
        1827.5001220703125,
        1542.5,
        127.5
      ],
      "bbox_max": [
        1832.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1722.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1722.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        190.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 165.0,
      "bbox_min": [
        1774.8236083984375,
        1555.0,
        140.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1845.0001220703125,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1555.0,
        165.0
      ],
      "bbox_max": [
        2014.9998779296875,
        1620.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1990.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1610.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0162353515625,
      "bbox_min": [
        2000.0,
        1601.9998779296875,
        165.0
      ],
      "bbox_max": [
        2014.9998779296875,
        1610.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        -0.0
      ],
      "plane_d": 2015.0047607421875,
      "bbox_min": [
        2014.9998779296875,
        1601.9998779296875,
        165.0
      ],
      "bbox_max": [
        2014.9998779296875,
        1609.9998779296875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -3.051748535654042e-06,
        0.0
      ],
      "plane_d": -1999.9951171875,
      "bbox_min": [
        1802.9998779296875,
        1569.9998779296875,
        140.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1845.0001220703125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1802.9998779296875,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1845.0001220703125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659252166748047,
        -0.25882142782211304,
        0.0
      ],
      "plane_d": -1288.8211669921875,
      "bbox_min": [
        1802.9998779296875,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1825.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        140.0
      ],
      "bbox_max": [
        1818.0,
        1825.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882142782211304,
        0.9659252166748047,
        0.0
      ],
      "plane_d": -1190.8414306640625,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659265279769897,
        -0.2588167190551758,
        -0.0
      ],
      "plane_d": 2265.77783203125,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659265279769897,
        0.2588167190551758,
        0.0
      ],
      "plane_d": 1354.742919921875,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588167190551758,
        0.9659265279769897,
        0.0
      ],
      "plane_d": -2143.2978515625,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659265279769897,
        0.2588167190551758,
        0.0
      ],
      "plane_d": -2199.86669921875,
      "bbox_min": [
        1805.8819580078125,
        1730.452880859375,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588167190551758,
        -0.9659265279769897,
        0.0
      ],
      "plane_d": 1256.763427734375,
      "bbox_min": [
        1810.452880859375,
        1730.452880859375,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588167190551758,
        -0.9659265279769897,
        -0.0
      ],
      "plane_d": 2209.208984375,
      "bbox_min": [
        1810.452880859375,
        1730.452880859375,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2512.62890625,
      "bbox_min": [
        1810.452880859375,
        1730.452880859375,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 89.5240478515625,
      "bbox_min": [
        1810.4530029296875,
        1730.4530029296875,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -23.613037109375,
      "bbox_min": [
        1810.4530029296875,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1789.547119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2431640625,
      "bbox_min": [
        1843.7059326171875,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1756.2940673828125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.35595703125,
      "bbox_min": [
        1843.7059326171875,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1848.5355224609375,
        1751.4644775390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1830.17041015625,
        1753.7060546875,
        140.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1753.7060546875,
        140.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2231.02734375,
      "bbox_min": [
        1838.53564453125,
        1753.7060546875,
        140.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1758.53564453125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1831.4644775390625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1833.7059326171875,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1761.4644775390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1843.7059326171875,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1843.7059326171875,
        1763.7059326171875,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1843.7059326171875,
        1768.5355224609375,
        140.0
      ],
      "bbox_max": [
        1848.5355224609375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.88278874399839e-06,
        1.0,
        0.0
      ],
      "plane_d": -1569.9901123046875,
      "bbox_min": [
        1999.9998779296875,
        1569.9998779296875,
        140.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1610.0001220703125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0162353515625,
      "bbox_min": [
        2000.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1610.0001220703125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2939084626850672e-05,
        -0.5299978256225586,
        0.847999095916748
      ],
      "plane_d": 730.310546875,
      "bbox_min": [
        2014.9998779296875,
        1570.0,
        140.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1610.0001220703125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2939141015522182e-05,
        0.5300001502037048,
        -0.8479976654052734
      ],
      "plane_d": -713.3544921875,
      "bbox_min": [
        2015.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        2025.0,
        1578.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        -0.0
      ],
      "plane_d": 2015.0047607421875,
      "bbox_min": [
        2015.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        2015.0,
        1578.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": -330.97119140625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1816.4444580078125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 179.3529510498047,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1816.4444580078125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05075879767537117,
        0.1894325464963913,
        -0.9805808663368225
      ],
      "plane_d": -71.74618530273438,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1816.4444580078125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320565223693848,
        -0.0,
        -0.5546908378601074
      ],
      "plane_d": 1625.9749755859375,
      "bbox_min": [
        1847.5,
        1700.4000244140625,
        159.67794799804688
      ],
      "bbox_max": [
        1847.7147216796875,
        1702.0096435546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0507580041885376,
        0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": -258.538330078125,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1816.4444580078125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320557475090027,
        3.213253194189747e-06,
        -0.5546919107437134
      ],
      "plane_d": -1435.996826171875,
      "bbox_min": [
        1832.28515625,
        1700.4000244140625,
        159.677978515625
      ],
      "bbox_max": [
        1832.4998779296875,
        1702.009521484375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 184.04165649414062,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1816.4444580078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883490443229675,
        0.5883490443229675,
        0.5546989440917969
      ],
      "plane_d": 14.858566284179688,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1896.4444580078125,
        1816.4444580078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883490443229675,
        -0.5883490443229675,
        -0.5546990036964417
      ],
      "plane_d": 89.90592956542969,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1816.4444580078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -79.27729797363281,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1816.4444580078125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1981.08251953125,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1792.5880126953125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -2150.265625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1792.5880126953125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036982417106628,
        0.21534967422485352,
        -0.5547013878822327
      ],
      "plane_d": -1720.8460693359375,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1792.5880126953125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036982417106628,
        0.21534952521324158,
        0.5547013878822327
      ],
      "plane_d": -1890.02978515625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1792.5880126953125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036984801292419,
        -0.2153497189283371,
        -0.5547010898590088
      ],
      "plane_d": -962.815673828125,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1792.5880126953125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036988973617554,
        -0.21534748375415802,
        0.5547013878822327
      ],
      "plane_d": -1132.004150390625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1792.5880126953125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21534736454486847,
        0.8036937713623047,
        -0.5547088980674744
      ],
      "plane_d": -881.286865234375,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320565223693848,
        -0.0,
        -0.5546908378601074
      ],
      "plane_d": 1625.9749755859375,
      "bbox_min": [
        1847.5,
        1700.4000244140625,
        156.85357666015625
      ],
      "bbox_max": [
        1849.5975341796875,
        1702.0096435546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534909307956696,
        0.8036984205245972,
        -0.5547013282775879
      ],
      "plane_d": -1673.7774658203125,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320557475090027,
        3.213253194189747e-06,
        -0.5546919107437134
      ],
      "plane_d": -1435.996826171875,
      "bbox_min": [
        1830.40234375,
        1700.4000244140625,
        156.85362243652344
      ],
      "bbox_max": [
        1832.4998779296875,
        1702.009521484375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153475135564804,
        0.8036943078041077,
        0.5547080039978027
      ],
      "plane_d": -1050.4736328125,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2153553068637848,
        0.8037027716636658,
        0.5546925663948059
      ],
      "plane_d": -1842.978759765625,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1830.17041015625,
        1753.7059326171875,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1830.17041015625,
        1753.7059326171875,
        145.0
      ],
      "bbox_max": [
        1841.4644775390625,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1753.7060546875,
        145.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1831.4644775390625,
        1753.7060546875,
        145.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": -2231.027587890625,
      "bbox_min": [
        1838.53564453125,
        1753.7060546875,
        145.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1758.53564453125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1763.7059326171875,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1843.7059326171875,
        1763.7059326171875,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1843.7059326171875,
        1768.5355224609375,
        145.0
      ],
      "bbox_max": [
        1848.5355224609375,
        1769.82958984375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2939141015522182e-05,
        0.5300001502037048,
        -0.8479976654052734
      ],
      "plane_d": -713.3544921875,
      "bbox_min": [
        1819.1884765625,
        1570.0,
        145.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1700.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        -0.0
      ],
      "plane_d": 2015.0047607421875,
      "bbox_min": [
        2014.9998779296875,
        1570.0,
        145.0
      ],
      "bbox_max": [
        2015.0,
        1609.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320565223693848,
        -0.0,
        -0.5546908378601074
      ],
      "plane_d": 1625.9749755859375,
      "bbox_min": [
        1819.1884765625,
        1610.0,
        145.0
      ],
      "bbox_max": [
        2000.0,
        1700.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1849.5975341796875,
        1610.0,
        145.0
      ],
      "bbox_max": [
        2000.0,
        1700.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1849.5975341796875,
        1610.0,
        145.0
      ],
      "bbox_max": [
        2000.0,
        1700.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21534736454486847,
        0.8036937713623047,
        -0.5547088980674744
      ],
      "plane_d": -881.286865234375,
      "bbox_min": [
        1849.5975341796875,
        1698.1728515625,
        149.93658447265625
      ],
      "bbox_max": [
        1860.8118896484375,
        1700.4000244140625,
        156.85357666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153475135564804,
        0.8036943078041077,
        0.5547080039978027
      ],
      "plane_d": -1050.4736328125,
      "bbox_min": [
        1852.4998779296875,
        1698.1728515625,
        149.93658447265625
      ],
      "bbox_max": [
        1860.8118896484375,
        1700.4000244140625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320557475090027,
        3.213253194189747e-06,
        -0.5546919107437134
      ],
      "plane_d": -1435.996826171875,
      "bbox_min": [
        1819.1884765625,
        1670.4000244140625,
        148.14637756347656
      ],
      "bbox_max": [
        1854.2088623046875,
        1700.4000244140625,
        160.07728576660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534909307956696,
        0.8036984205245972,
        -0.5547013282775879
      ],
      "plane_d": -1673.7774658203125,
      "bbox_min": [
        1819.1884765625,
        1698.1729736328125,
        149.9366455078125
      ],
      "bbox_max": [
        1830.40234375,
        1700.4000244140625,
        156.85362243652344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2153553068637848,
        0.8037027716636658,
        0.5546925663948059
      ],
      "plane_d": -1842.978759765625,
      "bbox_min": [
        1819.1884765625,
        1698.1729736328125,
        149.9366455078125
      ],
      "bbox_max": [
        1827.5,
        1700.4000244140625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153475135564804,
        0.8036943078041077,
        0.5547080039978027
      ],
      "plane_d": -1050.4736328125,
      "bbox_min": [
        1825.791015625,
        1698.1728515625,
        148.14637756347656
      ],
      "bbox_max": [
        1854.2088623046875,
        1700.4000244140625,
        160.07728576660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2153553068637848,
        0.8037027716636658,
        0.5546925663948059
      ],
      "plane_d": -1842.978759765625,
      "bbox_min": [
        1825.791015625,
        1698.1729736328125,
        148.14637756347656
      ],
      "bbox_max": [
        1841.492919921875,
        1700.4000244140625,
        160.07728576660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05075879767537117,
        0.1894325464963913,
        -0.9805808663368225
      ],
      "plane_d": -71.74618530273438,
      "bbox_min": [
        1838.507080078125,
        1700.0,
        160.0
      ],
      "bbox_max": [
        1841.492919921875,
        1700.4000244140625,
        160.07728576660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0507580041885376,
        0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": -258.538330078125,
      "bbox_min": [
        1838.507080078125,
        1700.0,
        160.0
      ],
      "bbox_max": [
        1840.0,
        1700.4000244140625,
        160.07728576660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1722.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        140.0
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        1.0,
        1.202938051392266e-06,
        0.0
      ],
      "plane_d": -1900.0018310546875,
      "bbox_min": [
        1780.0,
        1555.0,
        135.0
      ],
      "bbox_max": [
        2025.0001220703125,
        2015.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.05075809732079506,
        -0.18943364918231964,
        -0.9805806875228882
      ],
      "plane_d": 383.7527160644531,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1845.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        135.0
      ],
      "bbox_max": [
        1818.0,
        1845.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        135.0
      ],
      "bbox_max": [
        1818.0,
        1825.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05075879767537117,
        0.1894325464963913,
        -0.9805808663368225
      ],
      "plane_d": -96.26071166992188,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1894332617521286,
        -0.05075898766517639,
        -0.9805806875228882
      ],
      "plane_d": -115.47698974609375,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18943364918231964,
        -0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": 581.6365966796875,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1894332766532898,
        0.0507580041885376,
        -0.9805808067321777
      ],
      "plane_d": 402.967529296875,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0507580041885376,
        0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": -283.0528564453125,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18943364918231964,
        0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": -294.1477966308594,
      "bbox_min": [
        1780.0,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0507580041885376,
        -0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": 570.5416870117188,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": -355.4857177734375,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        -0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 642.9745483398438,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 154.8384246826172,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1386750191450119,
        -0.1386750191450119,
        -0.9805806875228882
      ],
      "plane_d": 132.65040588378906,
      "bbox_min": [
        1788.0384521484375,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2431640625,
      "bbox_min": [
        1843.7059326171875,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1756.2940673828125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.35595703125,
      "bbox_min": [
        1843.7059326171875,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1848.5355224609375,
        1751.4644775390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1830.17041015625,
        1753.7060546875,
        135.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1753.7060546875,
        135.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2231.02734375,
      "bbox_min": [
        1838.53564453125,
        1753.7060546875,
        135.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1758.53564453125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1831.4644775390625,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1833.7059326171875,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1761.4644775390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1843.7059326171875,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1843.7059326171875,
        1763.7059326171875,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1843.7059326171875,
        1768.5355224609375,
        135.0
      ],
      "bbox_max": [
        1848.5355224609375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1965.0,
      "bbox_min": [
        1899.9998779296875,
        1593.9998779296875,
        135.0
      ],
      "bbox_max": [
        2025.0001220703125,
        2015.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070939540863037,
        -1.7263459085370414e-05,
        -0.7071196436882019
      ],
      "plane_d": 1494.6397705078125,
      "bbox_min": [
        1978.71875,
        1980.0,
        135.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2015.0,
        135.0057373046875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2010.0,
      "bbox_min": [
        1978.71875,
        2000.0,
        135.0
      ],
      "bbox_max": [
        1982.5,
        2015.0,
        135.0057373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.228306013625115e-05,
        1.0,
        0.0
      ],
      "plane_d": -2014.93603515625,
      "bbox_min": [
        1978.71875,
        2014.9998779296875,
        135.0
      ],
      "bbox_max": [
        1982.5,
        2015.0,
        135.0057373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.2285144698107615e-05,
        1.0,
        0.0
      ],
      "plane_d": -1985.0638427734375,
      "bbox_min": [
        1978.7188720703125,
        1980.0,
        135.0
      ],
      "bbox_max": [
        1982.5,
        1985.0,
        135.0057373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707105815410614,
        0.7071077823638916,
        -0.0
      ],
      "plane_d": -2661.7783203125,
      "bbox_min": [
        1900.0,
        1700.4000244140625,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9663520455360413,
        0.25722306966781616,
        -4.129499211558141e-05
      ],
      "plane_d": -2346.757080078125,
      "bbox_min": [
        1930.0,
        1700.4000244140625,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1820.4000244140625,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9654906392097473,
        -0.26043805480003357,
        0.0
      ],
      "plane_d": -1433.99072265625,
      "bbox_min": [
        1930.0,
        1700.4000244140625,
        135.0
      ],
      "bbox_max": [
        1960.0,
        1790.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": 2344.82421875,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        135.0
      ],
      "bbox_max": [
        1958.0,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9654915928840637,
        0.26043444871902466,
        0.0
      ],
      "plane_d": 1432.06787109375,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        135.0
      ],
      "bbox_max": [
        1958.0,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1930.0,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        135.0
      ],
      "bbox_max": [
        1950.177490234375,
        1790.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1731.0001220703125,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        135.0
      ],
      "bbox_max": [
        1950.177490234375,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1930.0,
        1790.0,
        135.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        0.0
      ],
      "plane_d": 1990.0216064453125,
      "bbox_min": [
        1990.0,
        1755.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1990.0,
        1755.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1755.0244140625,
      "bbox_min": [
        1990.0001220703125,
        1755.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1764.3232421875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1764.3232421875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1855.0244140625,
      "bbox_min": [
        1989.9998779296875,
        1764.3232421875,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4413466235273518e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1899.9512939453125,
      "bbox_min": [
        1989.9998779296875,
        1855.0,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1989.9534912109375,
      "bbox_min": [
        1989.9998779296875,
        1899.9998779296875,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2207180589030031e-05,
        1.0,
        -0.0
      ],
      "plane_d": -1910.0244140625,
      "bbox_min": [
        1990.0001220703125,
        1900.0001220703125,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        0.0
      ],
      "plane_d": -2000.0233154296875,
      "bbox_min": [
        2000.0,
        1900.0001220703125,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        0.0
      ],
      "plane_d": -2000.022705078125,
      "bbox_min": [
        1990.0001220703125,
        1855.0,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1865.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1865.0,
      "bbox_min": [
        1990.0001220703125,
        1855.0001220703125,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1865.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0001220703125,
      "bbox_min": [
        1990.0001220703125,
        1855.0001220703125,
        135.0
      ],
      "bbox_max": [
        1990.0001220703125,
        1865.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1805.0,
      "bbox_min": [
        1990.0,
        1764.3232421875,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1815.0,
      "bbox_min": [
        1990.0,
        1805.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1805.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1805.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1764.3232421875,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.5649475599021088e-11,
        -4.882771008851705e-06
      ],
      "plane_d": 2015.0006103515625,
      "bbox_min": [
        2014.9998779296875,
        1593.9998779296875,
        135.0
      ],
      "bbox_max": [
        2014.9998779296875,
        1609.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1990.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1655.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1655.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1990.0,
        1655.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1655.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1715.0,
      "bbox_min": [
        1990.0,
        1705.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1705.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1705.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1990.0,
        1705.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1705.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1755.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.202938051392266e-06,
        0.0
      ],
      "plane_d": -1900.0018310546875,
      "bbox_min": [
        1847.4998779296875,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547002553939819
      ],
      "plane_d": 1601.69677734375,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2696099247477832e-06,
        -0.8320503234863281,
        -0.5547002553939819
      ],
      "plane_d": 1743.147705078125,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320565223693848,
        0.5546908378601074
      ],
      "plane_d": -1722.35546875,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 170.1741943359375,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1990.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883490443229675,
        0.5883490443229675,
        0.5546989440917969
      ],
      "plane_d": 28.726043701171875,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1990.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153475135564804,
        0.8036943078041077,
        0.5547080039978027
      ],
      "plane_d": -1036.60595703125,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1990.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1839.476806640625,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1990.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866466045379639,
        0.32583048939704895,
        0.5244250297546387
      ],
      "plane_d": 746.0687866210938,
      "bbox_min": [
        1847.4998779296875,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1990.0,
        129.43020629882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32584020495414734,
        0.786644458770752,
        0.5244221091270447
      ],
      "plane_d": -1022.2903442382812,
      "bbox_min": [
        1851.1611328125,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1990.0,
        128.71722412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        0.5547001361846924
      ],
      "plane_d": 1404.0848388671875,
      "bbox_min": [
        1897.9903564453125,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1770.11865234375,
        123.92801666259766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583528757095337,
        0.7866458296775818,
        -0.5244231224060059
      ],
      "plane_d": -888.574462890625,
      "bbox_min": [
        1854.6966552734375,
        1982.8033447265625,
        127.5
      ],
      "bbox_max": [
        1860.0001220703125,
        1985.0001220703125,
        128.71722412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866413593292236,
        0.3258398175239563,
        -0.5244269967079163
      ],
      "plane_d": 879.7692260742188,
      "bbox_min": [
        1852.5,
        1977.5,
        127.5
      ],
      "bbox_max": [
        1856.0819091796875,
        1984.1885986328125,
        129.43020629882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583528757095337,
        0.7866458296775818,
        -0.5244231224060059
      ],
      "plane_d": -888.574462890625,
      "bbox_min": [
        1853.7867431640625,
        1982.8033447265625,
        127.5
      ],
      "bbox_max": [
        1856.0819091796875,
        1984.1885986328125,
        129.43020629882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1792.588134765625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1081.449462890625,
      "bbox_min": [
        1847.4998779296875,
        1727.929443359375,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320565223693848,
        0.5546907782554626
      ],
      "plane_d": -1524.7418212890625,
      "bbox_min": [
        1897.990234375,
        1749.8812255859375,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1752.4998779296875,
        123.92813110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659233689308167,
        0.2588285207748413,
        -0.0
      ],
      "plane_d": -2255.79296875,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659233689308167,
        -0.2588285207748413,
        0.0
      ],
      "plane_d": -1344.7164306640625,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2568.5400390625,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.524169921875,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5795432925224304,
        0.1552942395210266,
        0.8000082969665527
      ],
      "plane_d": -1451.8516845703125,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5795527100563049,
        -0.15529675781726837,
        0.8000009655952454
      ],
      "plane_d": -905.228271484375,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -1639.5230712890625,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1860.5814208984375,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        -0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -146.11451721191406,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1860.5814208984375,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882601737976074,
        -0.9659239649772644,
        0.0
      ],
      "plane_d": 1200.830810546875,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1851.8828125,
        1781.755859375,
        124.75625610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588217258453369,
        0.9659250974655151,
        -0.0
      ],
      "plane_d": -2199.2158203125,
      "bbox_min": [
        1847.4998779296875,
        1738.7801513671875,
        120.0
      ],
      "bbox_max": [
        1851.8828125,
        1781.755859375,
        124.75625610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529559552669525,
        -0.5795543193817139,
        0.7999999523162842
      ],
      "plane_d": 622.098388671875,
      "bbox_min": [
        1849.499755859375,
        1738.7801513671875,
        123.0
      ],
      "bbox_max": [
        1851.8828125,
        1781.219970703125,
        124.75625610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529289841651917,
        0.579554557800293,
        0.8000004291534424
      ],
      "plane_d": -1417.9283447265625,
      "bbox_min": [
        1849.499755859375,
        1778.4820556640625,
        123.0
      ],
      "bbox_max": [
        1851.8826904296875,
        1781.219970703125,
        124.75614166259766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036980032920837,
        -0.2153484970331192,
        -0.5547022223472595
      ],
      "plane_d": 1980.92431640625,
      "bbox_min": [
        1852.4998779296875,
        1698.1728515625,
        126.0
      ],
      "bbox_max": [
        1899.999755859375,
        1792.588134765625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6051924325875007e-06,
        -0.8320494890213013,
        -0.5547015070915222
      ],
      "plane_d": 1545.5390625,
      "bbox_min": [
        1897.9903564453125,
        1767.5,
        131.07199096679688
      ],
      "bbox_max": [
        1899.999755859375,
        1770.11865234375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036984205245972,
        0.21534909307956696,
        -0.5547013282775879
      ],
      "plane_d": 1222.897216796875,
      "bbox_min": [
        1852.4998779296875,
        1698.1728515625,
        126.0
      ],
      "bbox_max": [
        1899.999755859375,
        1752.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.173072855133796e-06,
        0.8320558071136475,
        -0.5546919703483582
      ],
      "plane_d": -1383.288330078125,
      "bbox_min": [
        1897.990234375,
        1749.8812255859375,
        131.07186889648438
      ],
      "bbox_max": [
        1899.999755859375,
        1752.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1081.449462890625,
      "bbox_min": [
        1895.5478515625,
        1727.411865234375,
        126.0
      ],
      "bbox_max": [
        1899.999755859375,
        1744.5443115234375,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2696193607553141e-06,
        0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": -1580.9114990234375,
      "bbox_min": [
        1847.4998779296875,
        1983.7132568359375,
        120.0
      ],
      "bbox_max": [
        1899.9993896484375,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583528757095337,
        0.7866458296775818,
        -0.5244231224060059
      ],
      "plane_d": -888.574462890625,
      "bbox_min": [
        1853.7867431640625,
        1983.7132568359375,
        127.5
      ],
      "bbox_max": [
        1860.0001220703125,
        1990.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.7438646864320617e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1998.5032958984375,
      "bbox_min": [
        1847.4998779296875,
        1991.3223876953125,
        120.0
      ],
      "bbox_max": [
        1899.9993896484375,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1847.4998779296875,
        1991.3223876953125,
        120.0
      ],
      "bbox_max": [
        1899.9993896484375,
        1998.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1996.5,
      "bbox_min": [
        1847.4998779296875,
        1991.3223876953125,
        120.0
      ],
      "bbox_max": [
        1899.9993896484375,
        1998.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833963394165,
        0.9238795638084412,
        0.0
      ],
      "plane_d": -1134.582275390625,
      "bbox_min": [
        1855.1715087890625,
        1996.5,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1998.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826810121536255,
        -0.9238806366920471,
        0.0
      ],
      "plane_d": 1132.740966796875,
      "bbox_min": [
        1847.4998779296875,
        1991.3223876953125,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1996.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833963394165,
        0.9238795638084412,
        0.0
      ],
      "plane_d": -1134.582275390625,
      "bbox_min": [
        1847.4998779296875,
        1993.322265625,
        120.0
      ],
      "bbox_max": [
        1855.171630859375,
        1996.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583779096603394,
        -0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": 908.2271728515625,
      "bbox_min": [
        1847.4998779296875,
        1999.822265625,
        120.0
      ],
      "bbox_max": [
        1860.0,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583823800086975,
        -0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": 1041.955078125,
      "bbox_min": [
        1852.5,
        2003.9644775390625,
        127.5
      ],
      "bbox_max": [
        1860.0,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1965.0,
      "bbox_min": [
        1899.9993896484375,
        1570.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1982.5,
      "bbox_min": [
        1899.9993896484375,
        1965.0,
        120.0
      ],
      "bbox_max": [
        1985.0001220703125,
        2077.5,
        135.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1985.0,
      "bbox_min": [
        1982.5,
        1965.0,
        120.0
      ],
      "bbox_max": [
        1985.0001220703125,
        2077.5,
        135.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1982.5,
        1980.0,
        123.0
      ],
      "bbox_max": [
        1985.0001220703125,
        2015.0001220703125,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1982.5,
        1980.0,
        123.0
      ],
      "bbox_max": [
        1985.0001220703125,
        2015.0001220703125,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.0501201763399877e-05,
        0.6246950626373291,
        0.7808688879013062
      ],
      "plane_d": -1346.9383544921875,
      "bbox_min": [
        1982.5,
        1980.0,
        123.0
      ],
      "bbox_max": [
        1985.0001220703125,
        2015.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.0503269954351708e-05,
        -0.6246764659881592,
        0.7808837294578552
      ],
      "plane_d": 1148.6795654296875,
      "bbox_min": [
        1982.5,
        1980.0,
        123.0
      ],
      "bbox_max": [
        1985.0001220703125,
        1995.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0500294087687507e-05,
        -0.6246764659881592,
        -0.7808837294578552
      ],
      "plane_d": 1346.122314453125,
      "bbox_min": [
        1982.5,
        1980.0,
        123.0
      ],
      "bbox_max": [
        1985.0001220703125,
        1995.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6246950626373291,
        -0.7808688282966614
      ],
      "plane_d": -1136.945068359375,
      "bbox_min": [
        1982.5,
        1980.0,
        123.0
      ],
      "bbox_max": [
        1985.0,
        1995.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0504177630064078e-05,
        0.6246950626373291,
        0.7808688282966614
      ],
      "plane_d": -1334.5653076171875,
      "bbox_min": [
        1982.5,
        1980.0,
        123.0
      ],
      "bbox_max": [
        1985.0,
        1995.0001220703125,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1980.0,
      "bbox_min": [
        1982.5,
        1980.0,
        125.0
      ],
      "bbox_max": [
        1985.0,
        1995.0001220703125,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.8830508603714406e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1995.096923828125,
      "bbox_min": [
        1982.5001220703125,
        1995.0,
        125.0
      ],
      "bbox_max": [
        1985.0,
        1995.0001220703125,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0501201763399877e-05,
        -0.6246950626373291,
        0.7808688879013062
      ],
      "plane_d": 1161.091552734375,
      "bbox_min": [
        1982.5,
        2000.0,
        123.0
      ],
      "bbox_max": [
        1985.0001220703125,
        2015.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6246950626373291,
        -0.7808688282966614
      ],
      "plane_d": 1358.711669921875,
      "bbox_min": [
        1982.5,
        2000.0,
        125.0
      ],
      "bbox_max": [
        1985.0001220703125,
        2015.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6246950626373291,
        -0.7808688282966614
      ],
      "plane_d": -1149.43896484375,
      "bbox_min": [
        1982.5,
        2000.0,
        125.0
      ],
      "bbox_max": [
        1985.0001220703125,
        2015.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.8825746489455923e-05,
        -1.0,
        0.0
      ],
      "plane_d": 2014.9031982421875,
      "bbox_min": [
        1982.5,
        2000.0,
        125.0
      ],
      "bbox_max": [
        1985.0001220703125,
        2015.0001220703125,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1982.5,
        2000.0,
        125.0
      ],
      "bbox_max": [
        1985.0,
        2000.0,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.8722508886858122e-06,
        -1.0,
        0.0
      ],
      "plane_d": 2030.005615234375,
      "bbox_min": [
        1899.9993896484375,
        1965.0,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2030.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238786697387695,
        0.38268566131591797
      ],
      "plane_d": -1863.25732421875,
      "bbox_min": [
        1899.9993896484375,
        1965.0,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2030.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": -864.7522583007812,
      "bbox_min": [
        1899.9993896484375,
        1965.0,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2030.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.09916345536476e-06,
        -0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": 664.071044921875,
      "bbox_min": [
        1899.9993896484375,
        1965.0,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2030.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.653643605299294e-06,
        -0.9238899350166321,
        0.3826584219932556
      ],
      "plane_d": 1827.66943359375,
      "bbox_min": [
        1899.9993896484375,
        1965.0,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2030.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2696193607553141e-06,
        0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": -1580.9114990234375,
      "bbox_min": [
        1899.9993896484375,
        1965.0,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2030.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1940.0,
      "bbox_min": [
        1940.0,
        1965.0,
        120.0
      ],
      "bbox_max": [
        1982.5,
        1990.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.554684579372406,
        0.832060694694519
      ],
      "plane_d": 995.9319458007812,
      "bbox_min": [
        1950.0,
        1979.9998779296875,
        120.0
      ],
      "bbox_max": [
        1970.0,
        1983.3331298828125,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1979.9998779296875,
      "bbox_min": [
        1950.0,
        1979.9998779296875,
        120.0
      ],
      "bbox_max": [
        1970.0,
        1983.3331298828125,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.554684579372406,
        -1.3542436136049218e-05,
        0.8320607542991638
      ],
      "plane_d": 979.3182373046875,
      "bbox_min": [
        1950.0,
        1980.0,
        120.0
      ],
      "bbox_max": [
        1970.0,
        1983.3331298828125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5546908378601074,
        -1.3541925909521524e-05,
        0.8320565819740295
      ],
      "plane_d": -1195.05712890625,
      "bbox_min": [
        1950.0,
        1980.0,
        120.0
      ],
      "bbox_max": [
        1970.0,
        1983.3331298828125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.4414661311311647e-05,
        0.0
      ],
      "plane_d": 1950.04833984375,
      "bbox_min": [
        1950.0,
        1980.0,
        120.0
      ],
      "bbox_max": [
        1970.0,
        1982.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.2285144698107615e-05,
        1.0,
        0.0
      ],
      "plane_d": -1985.0638427734375,
      "bbox_min": [
        1978.724609375,
        1980.0,
        131.22462463378906
      ],
      "bbox_max": [
        1982.5,
        1985.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.103143095970154e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1984.3804931640625,
      "bbox_min": [
        1959.0,
        1984.5,
        126.7502212524414
      ],
      "bbox_max": [
        1961.0001220703125,
        1985.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1959.0,
      "bbox_min": [
        1959.0,
        1984.5,
        126.7502212524414
      ],
      "bbox_max": [
        1961.0001220703125,
        1985.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00024420025874860585,
        -0.0
      ],
      "plane_d": -1961.4847412109375,
      "bbox_min": [
        1959.0,
        1984.5,
        126.75044250488281
      ],
      "bbox_max": [
        1961.0001220703125,
        1985.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944708704948425,
        0.44712623953819275
      ],
      "plane_d": 1716.5040283203125,
      "bbox_min": [
        1959.0,
        1984.5,
        131.0
      ],
      "bbox_max": [
        1961.0001220703125,
        1985.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1959.989990234375,
      "bbox_min": [
        1959.9998779296875,
        1984.9998779296875,
        127.5
      ],
      "bbox_max": [
        1959.9998779296875,
        1987.999755859375,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8320565223693848,
        0.5546908378601074
      ],
      "plane_d": -1722.35546875,
      "bbox_min": [
        1899.9993896484375,
        1980.0,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2030.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1940.0,
      "bbox_min": [
        1940.0,
        1980.0,
        120.0
      ],
      "bbox_max": [
        1970.0001220703125,
        1990.0001220703125,
        127.5002212524414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1949.9998779296875,
        1980.0,
        120.0
      ],
      "bbox_max": [
        1970.0001220703125,
        1990.0001220703125,
        127.5002212524414
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -2.4413466235273518e-05,
        1.0,
        3.662020026240498e-05
      ],
      "plane_d": -1984.956787109375,
      "bbox_min": [
        1949.9998779296875,
        1980.0,
        120.0
      ],
      "bbox_max": [
        1970.0001220703125,
        1990.0001220703125,
        125.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -2.4413466235273518e-05,
        0.0
      ],
      "plane_d": -1969.95166015625,
      "bbox_min": [
        1949.9998779296875,
        1980.0,
        120.0
      ],
      "bbox_max": [
        1970.0001220703125,
        1985.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.554684579372406,
        -1.3542436136049218e-05,
        0.8320607542991638
      ],
      "plane_d": 979.3182373046875,
      "bbox_min": [
        1949.9998779296875,
        1982.0,
        123.0
      ],
      "bbox_max": [
        1953.0,
        1985.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1955.0,
      "bbox_min": [
        1955.0,
        1985.0,
        120.0
      ],
      "bbox_max": [
        1965.0,
        1990.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1965.0,
      "bbox_min": [
        1955.0,
        1985.0,
        120.0
      ],
      "bbox_max": [
        1965.0,
        1990.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.554684579372406,
        0.0,
        0.832060694694519
      ],
      "plane_d": 982.0648803710938,
      "bbox_min": [
        1955.0,
        1985.0,
        123.0
      ],
      "bbox_max": [
        1965.0,
        1988.000244140625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -1192.3280029296875,
      "bbox_min": [
        1962.0,
        1985.0,
        123.0
      ],
      "bbox_max": [
        1965.0,
        1988.000244140625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1985.0,
      "bbox_min": [
        1959.0,
        1984.5,
        125.0
      ],
      "bbox_max": [
        1961.0001220703125,
        1986.6669921875,
        127.5002212524414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.103143095970154e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1984.3804931640625,
      "bbox_min": [
        1959.0,
        1984.5,
        125.0
      ],
      "bbox_max": [
        1961.0001220703125,
        1985.0,
        127.5002212524414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00024420025874860585,
        -0.0
      ],
      "plane_d": -1961.4847412109375,
      "bbox_min": [
        1959.0,
        1984.5,
        125.0
      ],
      "bbox_max": [
        1961.0001220703125,
        1985.0,
        127.5002212524414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1959.0,
      "bbox_min": [
        1959.0,
        1984.5,
        125.0
      ],
      "bbox_max": [
        1959.0,
        1985.0,
        127.5002212524414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1959.989990234375,
      "bbox_min": [
        1959.9998779296875,
        1984.9998779296875,
        125.0
      ],
      "bbox_max": [
        1959.9998779296875,
        1986.6669921875,
        127.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.2696099247477832e-06,
        -0.8320503234863281,
        -0.5547002553939819
      ],
      "plane_d": 1743.147705078125,
      "bbox_min": [
        1899.9993896484375,
        1984.9998779296875,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2030.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        1.627604251552839e-05
      ],
      "plane_d": -1940.0020751953125,
      "bbox_min": [
        1939.9998779296875,
        2004.9998779296875,
        120.0
      ],
      "bbox_max": [
        1982.5,
        2030.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.554684579372406,
        0.832060694694519
      ],
      "plane_d": -1220.032958984375,
      "bbox_min": [
        1950.0,
        2011.6663818359375,
        120.0
      ],
      "bbox_max": [
        1970.0,
        2015.0,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2015.0,
      "bbox_min": [
        1950.0,
        2011.6663818359375,
        120.0
      ],
      "bbox_max": [
        1970.0,
        2015.0,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.554684579372406,
        -0.0,
        0.832060694694519
      ],
      "plane_d": -1195.0721435546875,
      "bbox_min": [
        1950.0,
        2011.6663818359375,
        120.0
      ],
      "bbox_max": [
        1970.0,
        2015.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 979.3232421875,
      "bbox_min": [
        1950.0,
        2011.66650390625,
        120.0
      ],
      "bbox_max": [
        1970.0,
        2015.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        1950.0,
        2012.999755859375,
        120.0
      ],
      "bbox_max": [
        1970.0,
        2015.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.228306013625115e-05,
        1.0,
        0.0
      ],
      "plane_d": -2014.93603515625,
      "bbox_min": [
        1978.7244873046875,
        2010.0,
        131.22462463378906
      ],
      "bbox_max": [
        1982.5,
        2015.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.103143095970154e-05,
        1.0,
        0.0
      ],
      "plane_d": -2009.8804931640625,
      "bbox_min": [
        1959.0,
        2009.4998779296875,
        127.49946594238281
      ],
      "bbox_max": [
        1961.0001220703125,
        2010.0001220703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999998807907104,
        -0.00048804288962855935,
        0.0
      ],
      "plane_d": -1960.0189208984375,
      "bbox_min": [
        1959.0,
        2009.4998779296875,
        127.49946594238281
      ],
      "bbox_max": [
        1961.0001220703125,
        2010.0001220703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1959.0,
      "bbox_min": [
        1959.0,
        2009.4998779296875,
        127.49968719482422
      ],
      "bbox_max": [
        1961.0001220703125,
        2010.0001220703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.458817759063095e-05,
        0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": -1856.2769775390625,
      "bbox_min": [
        1959.0,
        2009.4998779296875,
        131.0
      ],
      "bbox_max": [
        1961.0001220703125,
        2010.0001220703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1959.989990234375,
      "bbox_min": [
        1960.0,
        2006.999755859375,
        128.2496795654297
      ],
      "bbox_max": [
        1960.0,
        2009.5,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547002553939819
      ],
      "plane_d": 1601.69677734375,
      "bbox_min": [
        1899.9993896484375,
        1984.9998779296875,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2015.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -6.1034784266666975e-06,
        -1.2206956853333395e-05
      ],
      "plane_d": -1939.9862060546875,
      "bbox_min": [
        1939.9998779296875,
        2004.9998779296875,
        120.0
      ],
      "bbox_max": [
        1970.0,
        2015.0,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1950.0,
        2005.0,
        120.0
      ],
      "bbox_max": [
        1970.0,
        2015.0,
        127.49968719482422
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2010.0,
      "bbox_min": [
        1950.0,
        2005.0,
        120.0
      ],
      "bbox_max": [
        1970.0,
        2015.0,
        125.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        1950.0,
        2009.9998779296875,
        120.0
      ],
      "bbox_max": [
        1970.0,
        2015.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 979.3232421875,
      "bbox_min": [
        1950.0,
        2010.0,
        123.0
      ],
      "bbox_max": [
        1953.0,
        2012.999755859375,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1955.0,
      "bbox_min": [
        1955.0,
        2005.0,
        120.0
      ],
      "bbox_max": [
        1965.0,
        2010.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1965.0,
      "bbox_min": [
        1955.0,
        2005.0,
        120.0
      ],
      "bbox_max": [
        1965.0,
        2010.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.554684579372406,
        0.0,
        0.832060694694519
      ],
      "plane_d": 982.0648803710938,
      "bbox_min": [
        1955.0,
        2006.9998779296875,
        123.0
      ],
      "bbox_max": [
        1965.0,
        2010.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -1192.3280029296875,
      "bbox_min": [
        1962.0,
        2006.9998779296875,
        123.0
      ],
      "bbox_max": [
        1965.0,
        2010.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.103143095970154e-05,
        1.0,
        0.0
      ],
      "plane_d": -2009.8804931640625,
      "bbox_min": [
        1959.0,
        2008.333251953125,
        125.0
      ],
      "bbox_max": [
        1961.0001220703125,
        2010.0001220703125,
        127.49968719482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.103888154029846e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 2009.61962890625,
      "bbox_min": [
        1959.0,
        2008.333251953125,
        125.0
      ],
      "bbox_max": [
        1961.0001220703125,
        2010.0001220703125,
        127.49968719482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1959.0,
      "bbox_min": [
        1959.0,
        2009.4998779296875,
        125.0
      ],
      "bbox_max": [
        1961.0001220703125,
        2010.0001220703125,
        127.49968719482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999998807907104,
        -0.00048804288962855935,
        0.0
      ],
      "plane_d": -1960.0189208984375,
      "bbox_min": [
        1960.9998779296875,
        2009.4998779296875,
        125.0
      ],
      "bbox_max": [
        1961.0001220703125,
        2010.0001220703125,
        127.49946594238281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1959.989990234375,
      "bbox_min": [
        1960.0,
        2008.333251953125,
        125.0
      ],
      "bbox_max": [
        1960.0,
        2009.5,
        126.75016784667969
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1899.9993896484375,
        1984.9998779296875,
        120.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2010.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1996.5,
      "bbox_min": [
        1899.9993896484375,
        1988.000244140625,
        120.0
      ],
      "bbox_max": [
        1965.0,
        2006.9998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.7438646864320617e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1998.5032958984375,
      "bbox_min": [
        1899.9993896484375,
        1996.5,
        120.0
      ],
      "bbox_max": [
        1965.0,
        2006.9998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1955.0,
      "bbox_min": [
        1929.9998779296875,
        1996.5,
        120.0
      ],
      "bbox_max": [
        1965.0,
        1998.4998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1965.0,
      "bbox_min": [
        1965.0,
        1996.5,
        120.0
      ],
      "bbox_max": [
        1965.0,
        1998.4998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        6.103888154029846e-05,
        -0.0
      ],
      "plane_d": -1930.121826171875,
      "bbox_min": [
        1929.9998779296875,
        1996.5,
        120.0
      ],
      "bbox_max": [
        1930.0,
        1998.4998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1955.0,
      "bbox_min": [
        1955.0,
        1998.4998779296875,
        120.0
      ],
      "bbox_max": [
        1965.0,
        2006.9998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1965.0,
      "bbox_min": [
        1965.0,
        1998.4998779296875,
        120.0
      ],
      "bbox_max": [
        1965.0,
        2006.9998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1955.0,
      "bbox_min": [
        1955.0,
        1988.000244140625,
        120.0
      ],
      "bbox_max": [
        1965.0,
        1996.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1965.0,
      "bbox_min": [
        1965.0,
        1988.000244140625,
        120.0
      ],
      "bbox_max": [
        1965.0,
        1996.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1955.0,
        1984.9998779296875,
        123.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2010.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.554684579372406,
        0.0,
        0.832060694694519
      ],
      "plane_d": 982.0648803710938,
      "bbox_min": [
        1955.0,
        1986.6668701171875,
        123.0
      ],
      "bbox_max": [
        1965.0,
        2008.333251953125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -1192.3280029296875,
      "bbox_min": [
        1962.0,
        1986.6668701171875,
        123.0
      ],
      "bbox_max": [
        1965.0,
        2008.333251953125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1959.989990234375,
      "bbox_min": [
        1959.0,
        1984.9998779296875,
        125.0
      ],
      "bbox_max": [
        1982.5001220703125,
        2010.0001220703125,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -6.103888154029846e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 2009.61962890625,
      "bbox_min": [
        1959.0,
        2009.4998779296875,
        126.75005340576172
      ],
      "bbox_max": [
        1960.0,
        2010.0,
        128.24978637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1959.0,
      "bbox_min": [
        1959.0,
        2009.5,
        126.75016784667969
      ],
      "bbox_max": [
        1959.0,
        2010.0,
        128.2496795654297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9663534164428711,
        0.25721797347068787,
        -0.0
      ],
      "plane_d": -2346.75634765625,
      "bbox_min": [
        1899.999755859375,
        1700.4000244140625,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1820.4000244140625,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9654908180236816,
        -0.2604371905326843,
        -1.739408435241785e-05
      ],
      "plane_d": -1433.9903564453125,
      "bbox_min": [
        1899.999755859375,
        1700.4000244140625,
        120.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9663532972335815,
        0.2572184205055237,
        0.0
      ],
      "plane_d": -2344.82421875,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        120.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -3.6051924325875007e-06,
        -0.8320494890213013,
        -0.5547015070915222
      ],
      "plane_d": 1545.5390625,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        120.0
      ],
      "bbox_max": [
        1958.993408203125,
        1794.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1930.0,
      "bbox_min": [
        1899.999755859375,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1839.476806640625,
      "bbox_min": [
        1899.999755859375,
        1772.5,
        125.39684295654297
      ],
      "bbox_max": [
        1901.8270263671875,
        1779.3197021484375,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1929.9998779296875,
        1790.0,
        120.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1929.9998779296875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        0.5547001361846924
      ],
      "plane_d": 1404.0848388671875,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        120.0
      ],
      "bbox_max": [
        1958.993408203125,
        1777.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -6.975398264330579e-06,
        2.0926194338244386e-05
      ],
      "plane_d": -1929.990234375,
      "bbox_min": [
        1899.999755859375,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1930.0,
        1777.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1839.476806640625,
      "bbox_min": [
        1899.999755859375,
        1770.11865234375,
        123.92801666259766
      ],
      "bbox_max": [
        1901.8270263671875,
        1773.9022216796875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9654915928840637,
        0.26043444871902466,
        0.0
      ],
      "plane_d": 1432.06787109375,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        120.0
      ],
      "bbox_max": [
        1958.993408203125,
        1760.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 131.99998474121094,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1958.993408203125,
        1760.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": -1678.537109375,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        7.398255547741428e-06,
        -4.932170668325853e-06
      ],
      "plane_d": -1930.0123291015625,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        120.0
      ],
      "bbox_max": [
        1950.177490234375,
        1752.5,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1081.449462890625,
      "bbox_min": [
        1899.999755859375,
        1740.6805419921875,
        125.3968505859375
      ],
      "bbox_max": [
        1901.8270263671875,
        1747.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0001220703125,
      "bbox_min": [
        1930.0,
        1726.0,
        120.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1930.0,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320565223693848,
        0.5546907782554626
      ],
      "plane_d": -1524.7418212890625,
      "bbox_min": [
        1899.999755859375,
        1742.5003662109375,
        120.0
      ],
      "bbox_max": [
        1930.0,
        1752.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        7.398255547741428e-06,
        0.0
      ],
      "plane_d": -1930.012939453125,
      "bbox_min": [
        1899.999755859375,
        1742.5003662109375,
        120.0
      ],
      "bbox_max": [
        1930.0,
        1752.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1081.449462890625,
      "bbox_min": [
        1899.999755859375,
        1746.0980224609375,
        123.92813110351562
      ],
      "bbox_max": [
        1901.8270263671875,
        1749.8812255859375,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 131.99998474121094,
      "bbox_min": [
        1948.6839599609375,
        1756.268310546875,
        123.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -6.103888154029846e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1790.1190185546875,
      "bbox_min": [
        1948.6839599609375,
        1789.9998779296875,
        123.0
      ],
      "bbox_max": [
        1952.0146484375,
        1794.9998779296875,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486891031265259,
        0.31621038913726807
      ],
      "plane_d": 1661.78955078125,
      "bbox_min": [
        1948.6839599609375,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1948.6839599609375,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1990.0,
        1755.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1755.0244140625,
      "bbox_min": [
        1990.0001220703125,
        1755.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1764.3232421875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1756.4769287109375,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1764.3232421875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1855.0244140625,
      "bbox_min": [
        1989.9998779296875,
        1764.3232421875,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4413466235273518e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1899.9512939453125,
      "bbox_min": [
        1989.9998779296875,
        1855.0,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1989.9534912109375,
      "bbox_min": [
        1989.9998779296875,
        1899.9998779296875,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2207180589030031e-05,
        1.0,
        -0.0
      ],
      "plane_d": -1910.0244140625,
      "bbox_min": [
        1990.0001220703125,
        1900.0001220703125,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        0.0
      ],
      "plane_d": -2000.0233154296875,
      "bbox_min": [
        2000.0,
        1900.0001220703125,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        0.0
      ],
      "plane_d": -2000.022705078125,
      "bbox_min": [
        1990.0001220703125,
        1855.0,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1865.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1865.0,
      "bbox_min": [
        1990.0001220703125,
        1855.0001220703125,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1865.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0001220703125,
      "bbox_min": [
        1990.0001220703125,
        1855.0001220703125,
        120.0
      ],
      "bbox_max": [
        1990.0001220703125,
        1865.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1805.0,
      "bbox_min": [
        1990.0,
        1764.3232421875,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1815.0,
      "bbox_min": [
        1990.0,
        1805.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1805.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1805.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1764.3232421875,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.5649475599021088e-11,
        -4.882771008851705e-06
      ],
      "plane_d": 2015.0006103515625,
      "bbox_min": [
        2014.9998779296875,
        1570.0,
        119.99995422363281
      ],
      "bbox_max": [
        2015.0,
        1602.178466796875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1665.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1610.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1990.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1655.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1715.0,
      "bbox_min": [
        1990.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1990.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1705.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1755.0244140625,
      "bbox_min": [
        1998.5230712890625,
        1755.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1755.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583823800086975,
        -0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": 1041.955078125,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        127.5
      ],
      "bbox_max": [
        1857.5,
        2006.893310546875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1847.5,
        1751.18701171875,
        131.50558471679688
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2430419921875,
      "bbox_min": [
        1847.5,
        1751.18701171875,
        131.50558471679688
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1847.5,
        1751.18701171875,
        131.50558471679688
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.3560791015625,
      "bbox_min": [
        1847.5,
        1751.18701171875,
        133.44677734375
      ],
      "bbox_max": [
        1848.5355224609375,
        1751.4644775390625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1847.5,
        1761.3763427734375,
        131.50558471679688
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1847.5,
        1768.5355224609375,
        133.44677734375
      ],
      "bbox_max": [
        1848.5355224609375,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.524541618091462e-07,
        0.5546908378601074
      ],
      "plane_d": -1591.307373046875,
      "bbox_min": [
        1722.0,
        1555.0001220703125,
        120.0
      ],
      "bbox_max": [
        1852.5,
        2006.893310546875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": -1211.35595703125,
      "bbox_min": [
        1722.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1994.949951171875,
      "bbox_min": [
        1722.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9654908776283264,
        0.2604372203350067,
        0.0
      ],
      "plane_d": -2120.94482421875,
      "bbox_min": [
        1722.0,
        1731.0,
        120.0
      ],
      "bbox_max": [
        1765.5384521484375,
        1767.722900390625,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1383.2957763671875,
      "bbox_min": [
        1750.0,
        1747.5,
        120.0
      ],
      "bbox_max": [
        1765.5384521484375,
        1767.722900390625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1750.0,
        1747.5,
        120.0
      ],
      "bbox_max": [
        1763.46728515625,
        1767.722900390625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1545.543212890625,
      "bbox_min": [
        1750.0,
        1767.5,
        134.6656036376953
      ],
      "bbox_max": [
        1750.5382080078125,
        1767.722900390625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -2136.398193359375,
      "bbox_min": [
        1750.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1750.0,
        1747.5,
        120.0
      ],
      "bbox_max": [
        1765.538330078125,
        1767.722900390625,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1404.1051025390625,
      "bbox_min": [
        1750.0,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1750.5382080078125,
        1767.722900390625,
        120.33439636230469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -65.40982055664062,
      "bbox_min": [
        1750.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1750.0,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1404.1051025390625,
      "bbox_min": [
        1750.0,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1765.53857421875,
        1772.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1545.543212890625,
      "bbox_min": [
        1750.0,
        1767.5,
        127.5
      ],
      "bbox_max": [
        1763.4674072265625,
        1772.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1840.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.627577694307547e-05,
        -1.0,
        2.712629793677479e-05
      ],
      "plane_d": 1839.9669189453125,
      "bbox_min": [
        1818.0,
        1830.0,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1840.0001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -1.627604251552839e-05
      ],
      "plane_d": -1829.998046875,
      "bbox_min": [
        1818.0001220703125,
        1830.0,
        120.0
      ],
      "bbox_max": [
        1828.0384521484375,
        1830.0001220703125,
        130.6474151611328
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5883490443229675,
        -0.5883490443229675,
        -0.5546990036964417
      ],
      "plane_d": 76.0384521484375,
      "bbox_min": [
        1751.3963623046875,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1830.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1545.543212890625,
      "bbox_min": [
        1751.3963623046875,
        1767.5,
        127.5
      ],
      "bbox_max": [
        1824.7940673828125,
        1830.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1808.8963623046875,
        1824.9998779296875,
        127.5
      ],
      "bbox_max": [
        1824.7940673828125,
        1830.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.627577694307547e-05,
        1.0,
        2.712629793677479e-05
      ],
      "plane_d": -1829.9737548828125,
      "bbox_min": [
        1818.0001220703125,
        1830.0,
        127.5
      ],
      "bbox_max": [
        1824.7940673828125,
        1830.0001220703125,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.21534575521945953,
        -0.8036996722221375,
        0.5547009110450745
      ],
      "plane_d": 999.9329833984375,
      "bbox_min": [
        1763.46728515625,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1830.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -1.627604251552839e-05
      ],
      "plane_d": -1829.998046875,
      "bbox_min": [
        1815.967529296875,
        1825.0,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1830.0001220703125,
        131.5587921142578
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1815.967529296875,
        1825.0,
        125.34430694580078
      ],
      "bbox_max": [
        1818.0,
        1825.0,
        129.6557159423828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        1763.46728515625,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.4996337890625,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1763.8814697265625,
        1727.929443359375,
        120.0
      ],
      "bbox_max": [
        1832.4996337890625,
        1792.0704345703125,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1404.1051025390625,
      "bbox_min": [
        1763.8814697265625,
        1748.5,
        120.0
      ],
      "bbox_max": [
        1782.0096435546875,
        1771.5,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1763.8814697265625,
        1748.5,
        120.0
      ],
      "bbox_max": [
        1777.990478515625,
        1752.5,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036968111991882,
        0.21535371243953705,
        0.5547019839286804
      ],
      "plane_d": -1876.1668701171875,
      "bbox_min": [
        1772.7774658203125,
        1727.929443359375,
        120.0
      ],
      "bbox_max": [
        1832.4996337890625,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1772.7774658203125,
        1748.5,
        120.0
      ],
      "bbox_max": [
        1782.009521484375,
        1752.4998779296875,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5795534253120422,
        0.15529534220695496,
        0.800000786781311
      ],
      "plane_d": 680.8850708007812,
      "bbox_min": [
        1816.234619140625,
        1760.0,
        120.0
      ],
      "bbox_max": [
        1832.4996337890625,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -78.23225402832031,
      "bbox_min": [
        1819.418701171875,
        1769.812255859375,
        120.0
      ],
      "bbox_max": [
        1832.4996337890625,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881677865982056,
        0.965926468372345,
        0.0
      ],
      "plane_d": -1246.7633056640625,
      "bbox_min": [
        1828.1173095703125,
        1778.4822998046875,
        120.0
      ],
      "bbox_max": [
        1832.4996337890625,
        1781.755615234375,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529058873653412,
        0.5795578956604004,
        0.7999984622001648
      ],
      "plane_d": -846.46044921875,
      "bbox_min": [
        1828.1173095703125,
        1778.4822998046875,
        123.0
      ],
      "bbox_max": [
        1830.499755859375,
        1781.2197265625,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036941885948181,
        -0.21534796059131622,
        -0.5547080636024475
      ],
      "plane_d": -976.6776123046875,
      "bbox_min": [
        1763.46728515625,
        1698.1729736328125,
        126.0
      ],
      "bbox_max": [
        1827.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1545.543212890625,
      "bbox_min": [
        1763.46728515625,
        1747.5,
        126.0
      ],
      "bbox_max": [
        1782.0096435546875,
        1772.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1383.2957763671875,
      "bbox_min": [
        1763.46728515625,
        1747.5,
        126.0
      ],
      "bbox_max": [
        1778.1728515625,
        1772.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1404.1051025390625,
      "bbox_min": [
        1763.46728515625,
        1747.5,
        126.0
      ],
      "bbox_max": [
        1778.1728515625,
        1772.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1763.46728515625,
        1747.5,
        126.0
      ],
      "bbox_max": [
        1771.4739990234375,
        1748.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8037027716636658,
        0.2153553068637848,
        -0.5546925663948059
      ],
      "plane_d": -1734.732666015625,
      "bbox_min": [
        1770.7066650390625,
        1698.1729736328125,
        126.0
      ],
      "bbox_max": [
        1827.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1383.2957763671875,
      "bbox_min": [
        1770.7066650390625,
        1747.5,
        126.0
      ],
      "bbox_max": [
        1782.009521484375,
        1752.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1770.7066650390625,
        1747.5,
        126.0
      ],
      "bbox_max": [
        1778.1729736328125,
        1748.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1776.869873046875,
        1747.5,
        126.0
      ],
      "bbox_max": [
        1778.9403076171875,
        1748.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1776.8695068359375,
        1698.1729736328125,
        126.0
      ],
      "bbox_max": [
        1827.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1404.1051025390625,
      "bbox_min": [
        1776.8695068359375,
        1771.4998779296875,
        126.0
      ],
      "bbox_max": [
        1778.940185546875,
        1772.4998779296875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534454822540283,
        -0.8036952018737793,
        -0.5547077059745789
      ],
      "plane_d": 1141.376708984375,
      "bbox_min": [
        1807.411865234375,
        1811.9615478515625,
        127.5
      ],
      "bbox_max": [
        1827.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.367607738866354e-07,
        -0.5546908378601074
      ],
      "plane_d": -1449.861328125,
      "bbox_min": [
        1822.499755859375,
        1555.0001220703125,
        120.0
      ],
      "bbox_max": [
        1852.5,
        2006.893310546875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -1.627604251552839e-05
      ],
      "plane_d": 1840.002197265625,
      "bbox_min": [
        1822.499755859375,
        1840.0,
        127.5
      ],
      "bbox_max": [
        1832.5,
        1840.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        131.50558471679688
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1831.4644775390625,
        1768.5355224609375,
        133.44677734375
      ],
      "bbox_max": [
        1832.4998779296875,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1827.5,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1852.5,
        2006.893310546875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1839.0,
      "bbox_min": [
        1830.499755859375,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1849.4998779296875,
        2002.650634765625,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1841.0,
      "bbox_min": [
        1839.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1849.4998779296875,
        2002.650634765625,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833963394165,
        0.0
      ],
      "plane_d": 942.2581176757812,
      "bbox_min": [
        1839.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1999.1298828125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        1839.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1840.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881677865982056,
        0.965926468372345,
        0.0
      ],
      "plane_d": -1246.7633056640625,
      "bbox_min": [
        1839.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882601737976074,
        -0.9659239649772644,
        0.0
      ],
      "plane_d": 1200.830810546875,
      "bbox_min": [
        1840.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588217258453369,
        0.9659250974655151,
        -0.0
      ],
      "plane_d": -2199.2158203125,
      "bbox_min": [
        1840.0001220703125,
        1783.4974365234375,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583779096603394,
        -0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": 908.2271728515625,
      "bbox_min": [
        1839.140380859375,
        1996.9454345703125,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1999.1298828125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833963394165,
        0.0
      ],
      "plane_d": 942.2581176757812,
      "bbox_min": [
        1841.0,
        1982.328369140625,
        120.0
      ],
      "bbox_max": [
        1847.56494140625,
        1993.3492431640625,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833963394165,
        0.9238795638084412,
        0.0
      ],
      "plane_d": -1134.582275390625,
      "bbox_min": [
        1845.1507568359375,
        1992.3492431640625,
        120.0
      ],
      "bbox_max": [
        1847.56494140625,
        1993.3492431640625,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588217258453369,
        0.9659250974655151,
        -0.0
      ],
      "plane_d": -2199.2158203125,
      "bbox_min": [
        1841.0,
        1736.5025634765625,
        120.0
      ],
      "bbox_max": [
        1849.4998779296875,
        1994.1507568359375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882601737976074,
        -0.9659239649772644,
        0.0
      ],
      "plane_d": 1200.830810546875,
      "bbox_min": [
        1841.0,
        1736.5025634765625,
        120.0
      ],
      "bbox_max": [
        1849.499755859375,
        1738.7801513671875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826810121536255,
        -0.9238806366920471,
        0.0
      ],
      "plane_d": 1132.740966796875,
      "bbox_min": [
        1846.56494140625,
        1990.93505859375,
        120.0
      ],
      "bbox_max": [
        1849.4998779296875,
        1994.1507568359375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833963394165,
        0.9238795638084412,
        0.0
      ],
      "plane_d": -1134.582275390625,
      "bbox_min": [
        1847.56494140625,
        1993.3492431640625,
        120.09761047363281
      ],
      "bbox_max": [
        1849.4998779296875,
        1994.1507568359375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881677865982056,
        0.965926468372345,
        0.0
      ],
      "plane_d": -1246.7633056640625,
      "bbox_min": [
        1830.499755859375,
        1781.2197265625,
        120.0
      ],
      "bbox_max": [
        1839.0,
        1783.4974365234375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        1827.5,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1852.5,
        2006.893310546875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866423726081848,
        -0.3258380591869354,
        0.5244265794754028
      ],
      "plane_d": -860.1085815429688,
      "bbox_min": [
        1828.5,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.5,
        2005.4791259765625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583779096603394,
        -0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": 908.2271728515625,
      "bbox_min": [
        1828.5,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.5,
        2005.4791259765625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529058873653412,
        0.5795578956604004,
        0.7999984622001648
      ],
      "plane_d": -846.46044921875,
      "bbox_min": [
        1828.5,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529559552669525,
        -0.5795543193817139,
        0.7999999523162842
      ],
      "plane_d": 622.098388671875,
      "bbox_min": [
        1828.5,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529289841651917,
        0.579554557800293,
        0.8000004291534424
      ],
      "plane_d": -1417.9283447265625,
      "bbox_min": [
        1828.5,
        1741.5181884765625,
        123.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -78.23225402832031,
      "bbox_min": [
        1828.5,
        1741.5181884765625,
        124.75595092773438
      ],
      "bbox_max": [
        1851.4998779296875,
        1778.4822998046875,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -1639.5230712890625,
      "bbox_min": [
        1849.8121337890625,
        1741.5181884765625,
        124.75614166259766
      ],
      "bbox_max": [
        1851.4998779296875,
        1778.4820556640625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        -0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -146.11451721191406,
      "bbox_min": [
        1849.812255859375,
        1741.5181884765625,
        124.75625610351562
      ],
      "bbox_max": [
        1851.4998779296875,
        1744.692626953125,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866421937942505,
        -0.32583850622177124,
        -0.5244266986846924
      ],
      "plane_d": -726.3786010742188,
      "bbox_min": [
        1827.5,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1852.5,
        2006.893310546875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866423726081848,
        -0.3258380591869354,
        0.5244265794754028
      ],
      "plane_d": -860.1085815429688,
      "bbox_min": [
        1827.5,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1852.5,
        2006.893310546875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583823800086975,
        -0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": 1041.955078125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1852.5,
        2006.893310546875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583779096603394,
        -0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": 908.2271728515625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1852.5,
        2006.893310546875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.3560791015625,
      "bbox_min": [
        1843.7059326171875,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1756.2940673828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2430419921875,
      "bbox_min": [
        1848.5355224609375,
        1751.4644775390625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1756.2940673828125,
        133.44677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.898681640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2231.02734375,
      "bbox_min": [
        1830.17041015625,
        1753.7060546875,
        126.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        126.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1830.17041015625,
        1763.7059326171875,
        126.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1763.7059326171875,
        126.0
      ],
      "bbox_max": [
        1831.4644775390625,
        1768.5355224609375,
        133.44677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1843.7059326171875,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1846.2940673828125,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1768.5355224609375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1848.5355224609375,
        1763.7059326171875,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1768.5355224609375,
        133.44677734375
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}